import { FieldActivityPlan } from './fieldActivityPlan';
import { Product } from './product';

export class FieldActivityPlanCostProduct {
  amount: number = null;
  name: string = null;
  quantity: number = null;
  quantityUnit: string = null;
  unitPrice: number = null;
  unit: string = null;
  plan: FieldActivityPlan = null;
  product: Product = null;
  category: string = null;

  constructor() {}
}
